import { http, HttpResponse } from "msw";
// Mock JWT token for testing
const MOCK_JOIN_TOKEN = "mock_header.mock_body.mock_signature";
export const clustersHandlers = [
    // POST /api/cluster/init - Initialize cluster
    http.post("/api/cluster/init", async ({ request })=>{
        const body = await request.json();
        const res = {
            node_id: "mock-node-id",
            message: body.description ? `Cluster initialized with node description: ${body.description}` : "Cluster initialized successfully as Control Plane"
        };
        return HttpResponse.json(res);
    }),
    // POST /api/cluster/join - Join cluster
    http.post("/api/cluster/join", async ()=>{
        const res = {
            node_id: "mock-node-id",
            message: "Successfully joined cluster"
        };
        return HttpResponse.json(res);
    }),
    // POST /api/cluster/control-plane/join-token - Generate join token
    http.post("/api/cluster/control-plane/join-token", ()=>{
        const res = {
            token: MOCK_JOIN_TOKEN
        };
        return HttpResponse.json(res);
    })
];
export default clustersHandlers;
